import { render, staticRenderFns } from "./BrandSearcher.vue?vue&type=template&id=72b8042d&scoped=true&"
import script from "./BrandSearcher.vue?vue&type=script&lang=ts&"
export * from "./BrandSearcher.vue?vue&type=script&lang=ts&"
import style0 from "./BrandSearcher.vue?vue&type=style&index=0&id=72b8042d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b8042d",
  null
  
)

export default component.exports